<template>
    <div :class="{'has-icon-right': saving}" class="form-group">
        <div class="input-group">
            <select v-if="!!protocol" :disabled="!editable" @change="protocol_changed" class="form-select">
                <option
                    v-for="protocol_choice in protocols"
                    :key="protocol_choice"
                    :value="protocol_choice"
                    :selected="protocol_choice===protocol"
                >
                    {{ protocol_choice }}
                </option>
            </select>
            <input type="text" :name="name" :id="id||name" :value="url" :placeholder="placeholder" :disabled="!editable" @blur="url_changed" class="form-input">
            <i v-if="saving" class="form-icon loading"></i>
        </div>
    </div>
</template>

<script type="text/javascript">
import addl_string_utilities from "../../mixins/AddlStringUtilities"
import url_input_mixin from "./url_input_mixin"

export default {
    name: "UrlInput",
    mounted () {
        this.parse_value(this.value)
    },
    watch: {
        value: "parse_value"
    },
    mixins: [addl_string_utilities, url_input_mixin],
    methods: {
        parse_value (value) {
            this.protocol = ""
            this.url = ""
            const matches = (value || "").match(/^((?:https?:)?\/\/)?(.*?)$/i)
            if(matches && !!matches[2]) {
                if(!matches[1] || (matches[1] !== "//")) this.protocol = "https://"
                else this.protocol = matches[1]
                this.url = matches[2]
            } else if(value) {
                this.protocol = "https://"
                this.url = value
            }
        },
        build_value () {
            if(this.url) return this.string_concat("", this.protocol || "https://", this.url)
            return ""
        },
        /** Triggered when input changes
         * @event input
         * @type {Event}
         */
        input_action () {
            this.$emit("input", this.build_value())
        },
        protocol_changed (event) {
            this.protocol = event.target.value
            this.input_action()
        },
        url_changed (event) {
            let url = event.target.value
            if(url && !url.match(/^https?:\/\//i)) url = "https://" + url.replace(/^\/\//, "")
            this.parse_value(url)
            this.input_action()
        }
    },
    computed: {
        protocols () {
            return ["http://", "https://"]
        }
    },
    props: {
        saving: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            protocol: "",
            url: ""
        }
    }
}
</script>
